/**
 * Centralized data-testid registry.
 */
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  submitButton: "auth-submit-button",
  errorMessage: "auth-error-message",
  logoutButton: "auth-logout-button",
};

export const SHELL = {
  sidebarLink: (key) => `shell-sidebar-link-${key}`,
  brandLink: "shell-brand-link",
  topbarTitle: "shell-topbar-title",
};

export const DASH = {
  kpi: (key) => `dash-kpi-${key}`,
  recentActivity: "dash-recent-activity",
  expiring: "dash-expiring",
};

export const SITES = {
  newButton: "sites-new-button",
  table: "sites-table",
  row: (id) => `sites-row-${id}`,
  rowOpen: (id) => `sites-row-open-${id}`,
};

export const WIZARD = {
  step: (n) => `wizard-step-${n}`,
  nameInput: "wizard-name-input",
  taglineInput: "wizard-tagline-input",
  nicheInput: "wizard-niche-input",
  templateCard: (key) => `wizard-template-${key}`,
  variantCard: (key) => `wizard-variant-${key}`,
  paletteCard: (key) => `wizard-palette-${key}`,
  fontCard: (key) => `wizard-font-${key}`,
  voiceCard: (key) => `wizard-voice-${key}`,
  prev: "wizard-prev",
  next: "wizard-next",
  create: "wizard-create",
};

export const SITEDETAIL = {
  tab: (key) => `sitedetail-tab-${key}`,
  ingestButton: "sitedetail-ingest-button",
  domainSearchInput: "sitedetail-domain-search-input",
  domainSearchButton: "sitedetail-domain-search-button",
  domainPurchase: (d) => `sitedetail-domain-purchase-${d}`,
  dnsAdd: "sitedetail-dns-add",
  dnsAddType: "sitedetail-dns-add-type",
  dnsAddName: "sitedetail-dns-add-name",
  dnsAddContent: "sitedetail-dns-add-content",
  dnsAddSubmit: "sitedetail-dns-add-submit",
  saveSettings: "sitedetail-save-settings",
  previewLink: "sitedetail-preview-link",
  publisherName: "sitedetail-publisher-name",
  publisherLogoUrl: "sitedetail-publisher-logo-url",
  logoGenerate: "sitedetail-logo-generate",
  logoApply: (v) => `sitedetail-logo-apply-${v}`,
  logoClear: "sitedetail-logo-clear",
  twitterHandle: "sitedetail-twitter-handle",
  ga4MeasurementId: "sitedetail-ga4-measurement-id",
  adsensePubId: "sitedetail-adsense-pub-id",
  adsenseSlot: (p) => `sitedetail-adsense-slot-${p}`,
  autoPublishToggle: "sitedetail-autopublish-toggle",
  autoPublishMinScore: "sitedetail-autopublish-min-score",
  autoPublishDailyCap: "sitedetail-autopublish-daily-cap",
  autoPublishRequireImage: "sitedetail-autopublish-require-image",
  ingestFrequency: "sitedetail-ingest-frequency",
  velocityRefresh: "sitedetail-velocity-refresh",
  snapshotsRebuild: "sitedetail-snapshots-rebuild",
  categoryNewName: "sitedetail-category-new-name",
  categoryAdd: "sitedetail-category-add",
  categoryRow: (slug) => `sitedetail-category-row-${slug}`,
  categoryDelete: (slug) => `sitedetail-category-delete-${slug}`,
  reclassifyDryRun: "sitedetail-reclassify-dry-run",
  reclassifyApply: "sitedetail-reclassify-apply",
  faqBackfillDryRun: "sitedetail-faq-backfill-dry-run",
  faqBackfillRun: "sitedetail-faq-backfill-run",
  legalRewriteBtn: (kind) => `sitedetail-legal-rewrite-${kind}`,
  legalResetBtn: (kind) => `sitedetail-legal-reset-${kind}`,
  legalPreviewLink: (kind) => `sitedetail-legal-preview-${kind}`,
  legalStatusBadge: (kind) => `sitedetail-legal-status-${kind}`,
  themePickerTab: (kind) => `theme-picker-tab-${kind}`,
  themeTile: (kind, value) => `theme-tile-${kind}-${value}`,
  themeApply: (kind, value) => `theme-apply-${kind}-${value}`,
  themeShuffleRoll: "theme-picker-shuffle-roll",
  themeShuffleApply: "theme-picker-shuffle-apply",
  themeShuffleChip: (kind) => `theme-picker-shuffle-chip-${kind}`,
  themeShuffleLock: (kind) => `theme-picker-shuffle-lock-${kind}`,
  themePresetSaveInput: "theme-picker-preset-save-input",
  themePresetSaveButton: "theme-picker-preset-save-button",
  themePresetRow: (id) => `theme-picker-preset-row-${id}`,
  themePresetApply: (id) => `theme-picker-preset-apply-${id}`,
  themePresetDelete: (id) => `theme-picker-preset-delete-${id}`,
};

export const MOD = {
  list: "mod-list",
  item: (id) => `mod-item-${id}`,
  rewriteButton: "mod-rewrite-button",
  publishButton: "mod-publish-button",
  rejectButton: "mod-reject-button",
  detailTitle: "mod-detail-title",
};

export const INBOX = {
  folder: (k) => `inbox-folder-${k}`,
  item: (id) => `inbox-item-${id}`,
  markRead: "inbox-mark-read",
  archive: "inbox-archive",
};

export const PUBLIC = {
  hero: "public-hero",
  articleCard: (id) => `public-article-card-${id}`,
  category: (slug) => `public-category-${slug}`,
  newsletterEmailInput: "public-newsletter-email-input",
  newsletterEmailSubmit: "public-newsletter-email-submit",
  newsletterSmsInput: "public-newsletter-sms-input",
  newsletterSmsSubmit: "public-newsletter-sms-submit",
  contactName: "public-contact-name",
  contactEmail: "public-contact-email",
  contactMessage: "public-contact-message",
  contactSubmit: "public-contact-submit",
  cookieAccept: "public-cookie-accept",
  cookieReject: "public-cookie-reject",
  unsubscribeEmail: "public-unsubscribe-email",
  unsubscribePhone: "public-unsubscribe-phone",
  unsubscribeSubmit: "public-unsubscribe-submit",
};
